import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200s-89.5-200-200-200-200 89.5-200 200 89.5 200 200 200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/circle.js
// module id = 1710
// module chunks = 0